import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'small';
}

function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  const isSmall = size === 'small';

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className={`relative overflow-hidden rounded-lg ${isSmall ? 'aspect-[3/4]' : 'aspect-[3/4]'}`}>
        <img
          src={comic.cover}
          alt={`${comic.title} - 韩漫在线阅读`}
          title={`${comic.title} - 韩漫漫画网热门推荐`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          width={comic.coverWidth}
          height={comic.coverHeight}
        />
        <div className={`absolute top-2 left-2 ${comic.status === '已完结' ? 'bg-secondary-500' : 'bg-primary-500'} text-background-50 text-xs px-2 py-0.5 rounded-full whitespace-nowrap`}>
          {comic.status}
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent p-3 pt-8">
          <div className="flex items-center gap-1 text-background-50 text-xs">
            <i className="ri-star-fill text-accent-500"></i>
            <span>{comic.rating}</span>
            <span className="mx-1">·</span>
            <i className="ri-eye-line"></i>
            <span>{comic.views > 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}</span>
          </div>
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {comic.title}
        </h3>
        {!isSmall && (
          <p className="mt-1 text-xs text-foreground-500 line-clamp-2">{comic.description}</p>
        )}
        <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500">
          <span>{comic.author}</span>
          <span>·</span>
          <span>{comic.category}</span>
        </div>
      </div>
    </Link>
  );
}

export default ComicCard;